import { useNavigate } from 'react-router-dom'
import Logo from '../components/Logo'

export default function LegalPage() {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #0a0e1a 0%, #111827 100%)', fontFamily: "'Noto Sans JP', sans-serif" }}>
      <header className="flex items-center gap-4 px-4 md:px-8 py-4 border-b border-white/10">
        <button onClick={() => navigate('/')} className="text-white/60 hover:text-white text-sm">← ホーム</button>
        <Logo size="sm" />
      </header>
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 text-white/70 text-sm leading-relaxed space-y-8">
        <section>
          <h1 className="text-2xl font-black text-white mb-4">利用規約</h1>
          <p className="mb-2">本サービス「ChemCraft」（以下「本サービス」）は、化学の学習を目的とした教育用Webアプリです。以下の条件に同意のうえご利用ください。</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>本サービスの学習コンテンツは学習目的で提供されます。内容の正確性には努めますが、試験の合格を保証するものではありません。</li>
            <li>本サービスの利用により生じた損害について、運営者は責任を負いません。</li>
            <li>本サービスの内容は予告なく変更・停止する場合があります。</li>
          </ul>
        </section>
        <section>
          <h2 className="text-xl font-black text-white mb-4">プライバシーポリシー</h2>
          <p className="mb-2">本サービスは、ログイン・学習進捗の保存のために以下の情報を取得・保存します。</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>メールアドレス（アカウント認証のため）</li>
            <li>学習進捗・スコア（学習記録の表示のため）</li>
          </ul>
          <p className="mt-2">取得した情報は、本サービスの提供・改善の目的以外には利用しません。認証・データ保存には Google Firebase を利用しています。</p>
        </section>
        <section>
          <h2 className="text-xl font-black text-white mb-4">お問い合わせ</h2>
          <p>ご意見・不具合のご報告は、運営者までご連絡ください。</p>
        </section>
      </div>
    </div>
  )
}
